import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function About() {
  const stats = [{
    value: '55',
    label: 'AU Member States',
    filled: true
  }, {
    value: '45+',
    label: 'Active Projects',
    filled: false
  }, {
    value: '£180M',
    label: 'Project Portfolio',
    filled: false
  }, {
    value: '150+',
    label: 'Partner Suppliers',
    filled: true
  }];
  return <section id="about" className="py-20 bg-white" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-23">
        <div className="mb-12" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-au-navy mb-4" data-id="element-25">
            Who We Are
          </h2>
          <div className="h-1 w-16 bg-au-gold" data-id="element-26"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-27">
          {/* Left: narrative + CTA */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-28">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-29">
              The African Union Commission serves as the Secretariat of the
              African Union, entrusted with executive functions across the
              continent. It is a strategic platform connecting Africa's member
              states with global partners — from governments and multilateral
              institutions to the private sector, civil society, and the African
              diaspora.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-30">
              The Commission coordinates flagship projects, manages procurement
              processes, fosters partnerships, and represents the continent's
              interests on the international stage — advancing the goals of
              Agenda 2063, Africa's blueprint for inclusive and sustainable
              development.
            </p>

            <a href="#projects" className="inline-flex items-center bg-au-green text-white px-6 py-3 rounded font-medium hover:bg-au-navy transition-colors group focus:outline-none focus:ring-2 focus:ring-au-green focus:ring-offset-2" data-id="element-31">
              Explore Our Projects
              <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-32" />
            </a>
          </motion.div>

          {/* Right: 2x2 stat cards */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-2 gap-5" data-id="element-33">
            {stats.map((stat, index) => <div key={index} className={`rounded-lg p-8 flex flex-col items-center justify-center text-center min-h-[140px] ${stat.filled ? 'bg-au-green text-white' : 'bg-white border border-gray-200'}`} data-id="element-34">
                <span className={`text-3xl md:text-4xl font-serif font-bold mb-1 ${stat.filled ? 'text-white' : 'text-au-green'}`} data-id="element-35">
                  {stat.value}
                </span>
                <span className={`text-sm font-medium ${stat.filled ? 'text-green-50' : 'text-gray-600'}`} data-id="element-36">
                  {stat.label}
                </span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}